import { render, staticRenderFns } from "./UserDepartment.vue?vue&type=template&id=ab18e424"
import script from "./UserDepartment.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDepartment.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports